import { render, staticRenderFns } from "./ContainerOptions.vue?vue&type=template&id=0c828f13"
import script from "./ContainerOptions.vue?vue&type=script&lang=js"
export * from "./ContainerOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports